// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RunCan = zod.object({
  "client_brief": zod.boolean(),
  "confirm_client_brief": zod.boolean(),
  "edit": zod.boolean(),
  "rerun": zod.boolean(),
  "seller_brief": zod.boolean()
});

export type RunCan = zod.input<typeof RunCan>;
export type RunCanOutput = zod.output<typeof RunCan>;
